import { Star, Quote } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { REVIEWS } from "@/data/reviews";

const Stars = ({ n }) => (
  <div className="flex gap-1">
    {[1, 2, 3, 4, 5].map((i) => (
      <Star key={i} className={`h-4 w-4 ${i <= n ? "fill-[#F5A800] text-[#F5A800]" : "text-white/20"}`} />
    ))}
  </div>
);

const Reviews = () => {
  if (!REVIEWS.length) return null;
  return (
    <section className="border-t border-[#1C2027] bg-[#0D1015] py-16 lg:py-24" data-testid="reviews-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <SectionHead index="05" eyebrow="Client Voices" title="What Welsh clients say" testid="reviews-heading" />
        <div className="mt-10 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {REVIEWS.map((r, i) => (
            <Reveal key={i} delay={(i % 3) * 0.08} y={18} className="h-full">
              <figure className="flex h-full flex-col justify-between border border-[#1C2027] bg-[#10131A] p-7" data-testid={`review-card-${i}`}>
                <div>
                  <div className="flex items-center justify-between">
                    <Stars n={r.rating} />
                    <Quote className="h-5 w-5 text-[#F5A800]/40" />
                  </div>
                  <blockquote className="mt-5 text-[15px] leading-relaxed text-[#C8CCD2]">“{r.quote}”</blockquote>
                </div>
                <figcaption className="mt-6 border-t border-[#1C2027] pt-4">
                  <p className="text-sm font-bold text-white">{r.name}</p>
                  <p className="mt-0.5 text-[11px] uppercase tracking-[0.18em] text-[#F5A800]/70">
                    {r.company} · {r.town}
                  </p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;
